import * as R from 'ramda';
const SET_RELATED_PROPERTIES = 'SET_RELATED_PROPERTIES';
const SET_REAL_ESTATE_IMAGES = 'SET_REAL_ESTATE_IMAGES';
const SET_POSITION = 'SET_POSITION';
const SET_H2 = 'SET_H2';
export default {
	namespaced: true,
	state: {
		relatedProperties: [],
		realEstateImages: null,
		h2: null,
		position: null
	},
	getters: {
		realEstateImagesSorted(state) {
			const byIsPreview = R.descend(R.prop('isPreview'));
			return R.sort(byIsPreview, R.defaultTo([], state.realEstateImages));
		}
	},
	actions: {
		setRelatedProperties({ commit }, relatedProperties) {
			commit(SET_RELATED_PROPERTIES, relatedProperties);
		},
		setRealEstateImages({ commit }, realEstateImages) {
			commit(SET_REAL_ESTATE_IMAGES, realEstateImages);
		},
		setH2({ commit }, h2) {
			commit(SET_H2, h2);
		},
		setPosition({ commit }, position) {
			commit(SET_POSITION, position);
		}
	},
	mutations: {
		[SET_RELATED_PROPERTIES](state, relatedProperties) {
			state.relatedProperties = relatedProperties;
		},
		[SET_REAL_ESTATE_IMAGES](state, realEstateImages) {
			state.realEstateImages = realEstateImages;
		},
		[SET_H2](state, h2) {
			state.h2 = h2;
		},
		[SET_POSITION](state, position) {
			state.position = position;
		}
	}
};
